import React, { useContext, useEffect } from 'react';
import { AppContext } from '~/providers/AppProvider';
import { getRegions } from '~/api/services/regions';
import { Trans } from '@lingui/react';
import SEO from '~/components/seo';
import RegionItem from '~/components/regions/regionItem';
import styled from 'styled-components';
import Layout from '~/components/layout';
import { SectionWrapperGrey, ContentWrapper, SectionWrapperWhite } from '~/styles/common';
import ErrorLayout from '~/components/errorLayout';

export default function RegionsPage({ regions }) {
  const appCtx = useContext(AppContext);
  console.log('Regions', regions);
  useEffect(() => {
    appCtx.actions.setLoading(false);
  }, []);

  if (regions === null || regions === undefined) {
    return (
      <Layout>
        <SEO title={'Regions page not found'} />
        <ErrorLayout />
      </Layout>
    );
  }
  return (
    <Layout>
      <SEO />

      <SectionWrapperWhite>
        <ContentWrapper>
          <HeadingSection>
            <DestinationsHeading>
              <Trans id="regions_page.heading" />
            </DestinationsHeading>
            <DestinationsDescrption>
              <Trans id="regions_page.description" />
            </DestinationsDescrption>
          </HeadingSection>
        </ContentWrapper>
      </SectionWrapperWhite>

      <SectionWrapperGrey>
        <ContentWrapper>
          {regions.map((region, id) => (
            <div key={id}>
              <SectionHeading className={id === 0 ? 'first' : ''}>{region.Name}</SectionHeading>
              <RegionsWrapper>
                {region.Cities.map((city) => (
                  <RegionItem key={city.Id} cityData={city} carousel={false} />
                ))}
              </RegionsWrapper>
            </div>
          ))}
        </ContentWrapper>
      </SectionWrapperGrey>
    </Layout>
  );
}

// export async function getStaticPaths() {
//     const paths = [
//         { params: { lang: 'en' } },
//         { params: { lang: 'es' } },
//         { params: { lang: 'de' } },
//     ];
//     return { paths: paths, fallback: false };
// }

// export async function getStaticProps(context) {
//     let regions = null;

//     await getRegions({
//         xLanguage: context.params.lang,
//     })
//         .then((response) => {
//             response;
//             regions = response.data;
//         })
//         .catch((e) => {
//             console.error(e);
//         });

//     return {
//         props: {
//             regions: regions,
//         },
//         revalidate: 1,
//     };
// }

export async function getServerSideProps({ params, res, req, query }) {
  let regions = null;

  await getRegions({
    xLanguage: query.lang,
  })
    .then((response) => {
      regions = response.data;
    })
    .catch((e) => {
      console.error(e);
    });

  res.setHeader('Cache-Control', 'public, s-maxage=300, stale-while-revalidate=59');

  return {
    props: {
      regions,
    },
  };
}

const RegionsWrapper = styled.div`
  display: flex;
  width: 100%;
  flex-wrap: wrap;
  margin-right: -1em;
  margin-left: -1em;
`;

const SectionHeading = styled.h2`
  margin-bottom: 0.5em;
  font-size: 32px;
  margin-top: 1.5rem;

  @media (max-width: 400px) {
    margin-top: 0.5em;

    &.first {
      margin-top: 0px;
    }
  }
`;

const HeadingSection = styled.div`
  background: white;
  display: flex;
  flex-direction: column;
`;

const DestinationsHeading = styled.div`
  font-size: 48px;
  text-align: left;
  letter-spacing: 0px;
  color: #17233c;
  margin-bottom: 10px;
  font-weight: 500;

  @media (max-width: 500px) {
    line-height: 36px;
    font-size: 33px;
  }
`;

const DestinationsDescrption = styled.div`
  font-size: 16px;
  letter-spacing: 0px;
  color: #4b5765;
`;
